import DivisionPage from "./DivisionPage";

export default function InfrastructureTransport() {
  return <DivisionPage slug="infrastructure-transport" />;
}
